import { FC, ReactNode } from 'react';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/rootReducerType';
import { Certification } from 'src/types/Certification';
import ForbiddenPage from 'src/pages/ForbiddenPage';
import useAuth from 'src/hooks/useAuth';
import LoadingScreen from 'src/components/LoadingScreen';

interface RenterResourceGuardProps {
  children: ReactNode;
}

const RenterResourceGuard: FC<RenterResourceGuardProps> = ({ children }) => {
  const { isInitialized } = useAuth();
  const { certificationId, householdId } = useParams<{
    certificationId: string;
    householdId: string;
  }>();

  const certifications = useSelector(
    (state: RootState) => state.newRenterInterface.certifications
  ) as Certification[];

  const certificationsLoaded = useSelector(
    (state: RootState) => state.newRenterInterface.certificationsLoaded
  );

  if (!certificationsLoaded || !isInitialized) {
    return <LoadingScreen />;
  }

  const belongsToUser = (certifications || []).some((c) => {
    if (certificationId) {
      return c.id === Number(certificationId);
    }
    if (householdId) {
      return c.cert_household?.user_household_id === Number(householdId);
    }
    return false;
  });

  if (!belongsToUser) {
    return <ForbiddenPage />;
  }

  return <>{children}</>;
};

export default RenterResourceGuard;
